module.exports = __webpack_public_path__ + "static/WEDDING E&M-244-294c02038ec45c605da4b68d983093e8.jpg";